import React from "react";
import "./styles.scss";
import { Controller, useFormContext } from "react-hook-form";

import { TimespanPicker } from "./TimespanPicker";
interface IHookFormTimespanSelectProps {
  name: string;
}

export const HookFormTimespanSelect: React.FC<IHookFormTimespanSelectProps> = (
  props
) => {
  const { name } = props;

  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <TimespanPicker timespan={field.value} setTimespan={field.onChange} />
      )}
    />
  );
};
